import React from "react";
import { Route, Redirect } from "react-router-dom";
import { isAuthenticated } from "../../services/auth";

const PublicRoute = ({ component: Component, ...rest }) => {

  return (
    <>
      <Route
        {...rest}
        render={(props) =>
          isAuthenticated() ? 
          (
            <Redirect
              to={{ pathname: "/MenuRapido", state: { from: props.location } }}
            />
          ) : (
            <Component {...props} />
          )
        }
      />
    </>
  );
  
};

export default PublicRoute;
